// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Appearance-module--buttons--3BLW2","button":"Appearance-module--button--2c9ph","selected":"Appearance-module--selected--2Yfmj"};